import { render } from "./educationCodeDialog.vue?vue&type=template&id=8d8721f0&scoped=true"
import script from "./educationCodeDialog.vue?vue&type=script&lang=js"
export * from "./educationCodeDialog.vue?vue&type=script&lang=js"

import "./educationCodeDialog.vue?vue&type=style&index=0&id=8d8721f0&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d8721f0"]])

export default __exports__